import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadAuftragsArtListStatus: 'idle',
    loadAuftragsArtListError: undefined as any,
    loadAuftragsArtListLastArgs: undefined as any,
    loadAuftragsArtStatus: 'idle',
    loadAuftragsArtError: undefined as any,
    saveAuftragsArtStatus: 'idle',
    saveAuftragsArtError: undefined as any,
    deleteAuftragsArtStatus: 'idle',
    deleteAuftragsArtError: undefined as any,

    auftragsArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadAuftragsArtList = createAsyncThunk('auftragsArtSlice/loadAuftragsArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().auftragsArtSlice.loadAuftragsArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftragsart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsArtListStatus } = getState().auftragsArtSlice
        return loadAuftragsArtListStatus !== 'pending'
    }
})

export const loadAuftragsArt = createAsyncThunk('auftragsArtSlice/loadAuftragsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurisauftragsart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadAuftragsArtStatus } = getState().auftragsArtSlice
        return loadAuftragsArtStatus !== 'pending'
    }
})

export const saveAuftragsArt = createAsyncThunk('auftragsArtSlice/saveAuftragsArt', async ({ auftragsArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (auftragsArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurisauftragsart/${ auftragsArt?.HDR_ID }/`,
            prepareData(auftragsArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurisauftragsart/`,
            prepareData(auftragsArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveAuftragsArtStatus } = getState().auftragsArtSlice
        return saveAuftragsArtStatus !== 'pending'
    }
})

export const deleteAuftragsArt = createAsyncThunk('auftragsArtSlice/deleteAuftragsArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurisauftragsart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteAuftragsArtStatus } = getState().auftragsArtSlice
        return deleteAuftragsArtStatus !== 'pending'
    }
})

const AuftragsArtSlice = createSlice({
    name: 'auftragsArtSlice',
    initialState,
    reducers: {
        resetloadAuftragsArtListError: (state) => {
            state.loadAuftragsArtListError = undefined
        },
        resetloadAuftragsArt: (state) => {
            state.formItem = undefined
            state.loadAuftragsArtError = undefined
        },
        resetloadAuftragsArtError: (state) => {
            state.loadAuftragsArtError = undefined
        },
        resetsaveAuftragsArt: (state) => {
            state.formItem = undefined
            state.saveAuftragsArtError = undefined
        },
        resetsaveAuftragsArtError: (state) => {
            state.saveAuftragsArtError = undefined
        },
        resetdeleteAuftragsArtError: (state) => {
            state.deleteAuftragsArtError = undefined
        },
        removeFromAuftragsArtListById: (state, action) => {
            state.auftragsArtList = state.auftragsArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromAuftragsArtListByIds: (state, action) => {
            state.auftragsArtList = state.auftragsArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.auftragsArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadAuftragsArtListStatus = 'preloaded'
            state.loadAuftragsArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.auftragsArtList = []
            state.loadAuftragsArtListStatus = 'idle'
            state.loadAuftragsArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadAuftragsArtList.pending, (state) => {
            state.loadAuftragsArtListStatus = 'pending'
            state.loadAuftragsArtListError = undefined
        })
        builder.addCase(loadAuftragsArtList.fulfilled, (state, action) => {
            state.loadAuftragsArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadAuftragsArtListLastArgs = action.payload.args

            {
                state.auftragsArtList = action.payload.data

            }
        })
        builder.addCase(loadAuftragsArtList.rejected, (state, action) => {
            state.loadAuftragsArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsArtListError = action.error.message
            } else {
                state.loadAuftragsArtListError = action.payload
            }
        })

        builder.addCase(loadAuftragsArt.pending, (state) => {
            state.loadAuftragsArtStatus = 'pending'
            state.loadAuftragsArtError = undefined
        })
        builder.addCase(loadAuftragsArt.fulfilled, (state, action) => {
            state.loadAuftragsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsArtList.push(newItem) }
                else { state.auftragsArtList[i] = { ...state.auftragsArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadAuftragsArt.rejected, (state, action) => {
            state.loadAuftragsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadAuftragsArtError = action.error.message
            } else {
                state.loadAuftragsArtError = action.payload
            }
        })

        builder.addCase(saveAuftragsArt.pending, (state) => {
            state.saveAuftragsArtStatus = 'pending'
            state.saveAuftragsArtError = undefined
        })
        builder.addCase(saveAuftragsArt.fulfilled, (state, action) => {
            state.saveAuftragsArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.auftragsArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.auftragsArtList.push(newItem) }
                else { state.auftragsArtList[i] = { ...state.auftragsArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveAuftragsArt.rejected, (state, action) => {
            state.saveAuftragsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveAuftragsArtError = action.error.message
            } else {
                state.saveAuftragsArtError = action.payload
            }
        })

        builder.addCase(deleteAuftragsArt.pending, (state) => {
            state.deleteAuftragsArtStatus = 'pending'
            state.deleteAuftragsArtError = undefined
        })
        builder.addCase(deleteAuftragsArt.fulfilled, (state, action) => {
            state.deleteAuftragsArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.auftragsArtList = state.auftragsArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.auftragsArtList = state.auftragsArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteAuftragsArt.rejected, (state, action) => {
            state.deleteAuftragsArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteAuftragsArtError = action.error.message
            } else {
                state.deleteAuftragsArtError = action.payload
            }
        })

    }
})

export const {
    resetloadAuftragsArtListError,
    resetloadAuftragsArt,
    resetloadAuftragsArtError,
    resetsaveAuftragsArt,
    resetsaveAuftragsArtError,
    resetdeleteAuftragsArtError,
    removeFromAuftragsArtListById,
    removeFromAuftragsArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = AuftragsArtSlice.actions
export default AuftragsArtSlice.reducer
